import { arrayMoveImmutable } from 'array-move';
import { v4 as uuidv4 } from 'uuid';
export default function getMappingManager({ mapping, setMapping, fields, defaultMappingOptions, isOptionAvailable, config }) {
	mapping = mapping.map((m) => {
		if (m.key) {
			return m;
		}
		return { ...m, key: uuidv4() };
	});

	const isOptionDisabled = (option) => {
		if (option.allow_multiple) {
			return false;
		}
		return mapping.reduce(function(result, current) {
			return current.wordpress && current.wordpress === option.value ? true : result;
		}, false);
	}

	const allSupportedAirtableTypes = Object.keys(defaultMappingOptions).reduce((result, groupName) => {
		result = result.concat(defaultMappingOptions[groupName].options.reduce((supported_sources, option) => {
			supported_sources = supported_sources.concat(option.supported_sources);
			return supported_sources;
		}, []));
		return result;
	}, []);

	const airtableFieldsOptions = fields.reduce(function (result, field) {
		if (allSupportedAirtableTypes.indexOf(field.type) === -1) {
			return result;
		}
		if (!result[field.group]) {
			result[field.group] = {
				label: field.group,
				options: []
			};
		}

		result[field.group].options.push(field);
		return result;
	}, {});

	const wordPressFieldsOptions = mapping.map((field) => {
		const mappingOptions = {};
		const airtableField = getAirtableFieldById(field.airtable, fields);

		// Filter options by post type
		for (const groupName in defaultMappingOptions) {
			const group = defaultMappingOptions[groupName];
			const groupOptions = group.options.filter(function(option) {
				return isOptionAvailable(option.value);
			});
			if (groupOptions.length > 0) {
				mappingOptions[groupName] = { ...group, options: groupOptions };
			}
		}

		// Filter options by supported types
		let airtableType = airtableField ? airtableField.type : '';
		for (const groupName in mappingOptions) {
			const group = mappingOptions[groupName];
			group.options = group.options.filter(function(option) {
				return option.supported_sources.indexOf(airtableType) > -1
			});
			if (group.options.length === 0) {
				delete mappingOptions[groupName];
			}
		}

		const rowValue = field.wordpress ?? null;

		// Check if some options must be disabled
		for (const groupName in mappingOptions) {
			const group = mappingOptions[groupName];
			group.options = group.options.map(function(option) {
				return {
					...option,
					enabled: option.enabled && (option.value === rowValue || !isOptionDisabled(option))
				};
			});
		}

		return mappingOptions;
	});

	const getAirtableFirstOption = () => {
		return fields.length > 0 ? fields[0].id : '';
	};

	const addMappingRow = () => {
		const airtableFirstOption = getAirtableFirstOption();

		setMapping([
			...mapping,
			{
				airtable: airtableFirstOption,
				wordpress: '',
				options: {},
				key: uuidv4()
			}
		]);
	};

	const updateAirtableField = (index, airtableFieldId) => {
		setMapping(mapping.map((el, i) => {
			if (i === index) {
				return {
					...el,
					airtable: airtableFieldId
				};
			}
			return el;
		}));
	};
	const updateWordPressField = (index, wordPressFieldId) => {
		setMapping(mapping.map((el, i) => {
			if (i === index) {
				return {
					...el,
					wordpress: wordPressFieldId
				};
			}
			return el;
		}));
	};
	const updateFieldOption = (index, optionName, optionValue) => {
		setMapping(mapping.map((el, i) => {
			if (i === index) {
				return {
					...el,
					options: {
						...el.options,
						[optionName]: optionValue
					}
				};
			}
			return el;
		}));
	};
	const removeMappingRow = (index) => {
		setMapping(mapping.filter((el, i) => i !== index));
	};

	const moveMappingRow = (oldIndex, newIndex) => {
		setMapping( arrayMoveImmutable(mapping, oldIndex, newIndex) );
	};

	const indexedWordPressFields = Object.keys(defaultMappingOptions).reduce(function (result, groupName) {
		defaultMappingOptions[groupName].options.forEach((field) => {
			result[field.value] = field;
		}, []);
		return result
	}, {});
	const getWordPressFieldById = (wordPressFieldId) => {
		return indexedWordPressFields[wordPressFieldId]
	};

	return { airtableFieldsOptions, wordPressFieldsOptions, getWordPressFieldById, addMappingRow, updateAirtableField, updateWordPressField, updateFieldOption, removeMappingRow, moveMappingRow };
}

const getAirtableFieldById = (airtableId, fields) => {
	return fields.find(function(field) {
		return field.id === airtableId;
	});
};



/**
 * Filter out invalid mapping fields.
 *
 * @param mapping
 * @param fields
 * @returns {*}
 */
export function sanitizeMapping(mapping, fields) {
	return mapping.filter((field) => {
		return !!getAirtableFieldById(field.airtable, fields);
	})
}
